import { Controller } from 'stimulus';
import 'dom-slider';

const { slideUp } = window.domSlider;

export default class SessionFormController extends Controller {
  connect() {
    if (this.element.classList.contains('ez-flash-message--auto-dismiss')) {
      setTimeout(() => {
        this.dismiss();
      }, 3000);
    }
  }

  dismiss() {
    slideUp({ element: this.element });
  }
}
